import { useDebugValue, useEffect, useState } from 'react';
import { usePageContext } from '../../layout/Page/pageProvider.js';

export default function useMediaQuery(queryInput, { defaultMatches = false } = {}) {
  const { useSSR } = usePageContext();
  const query = queryInput.replace(/^@media( ?)/m, '');

  const [match, setMatch] = useState(useSSR ? false : defaultMatches);

  function CallUseDebugValue() {
    useDebugValue({
      query,
      match,
    });
  }

  useEffect(() => {
    if (typeof window.matchMedia === 'undefined') {
      return;
    }

    const updateMatch = (e) => {
      setMatch(e.matches);
    };

    const queryList = window.matchMedia(query);
    setMatch(queryList.matches);
    queryList.addEventListener('change', updateMatch);

    // eslint-disable-next-line consistent-return
    return () => {
      queryList.removeEventListener('change', updateMatch);
    };
  }, [query]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      // do nothing to satisfy SonarQube linting
    }
  }, [process.env.NODE_ENV]);

  if (process.env.NODE_ENV !== 'production') {
    CallUseDebugValue();
  }

  return match;
}
